import React, { useState, useMemo } from 'react';
import { FileText } from 'lucide-react';
import SearchBar from '../components/SearchBar';
import PolicyCategoryCard from '../components/PolicyCategoryCard';
import { mockPolicies } from '../data/mockPolicies';

const SettingsPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedCategory, setExpandedCategory] = useState("Employee Policies");
  
  const filteredPolicies = useMemo(() => {
    return mockPolicies.map(category => ({
      ...category,
      policies: category.policies.filter(policy => 
        policy.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        policy.description.toLowerCase().includes(searchQuery.toLowerCase())
      )
    })).filter(category => category.policies.length > 0);
  }, [searchQuery]);

  return (
    <div className="space-y-6">
      <div className="sticky top-0 z-10 bg-white/90 backdrop-blur-sm dark:bg-gray-800/80 py-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">HRMS Policies</h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Manage and configure company policies
            </p>
          </div>
          <SearchBar value={searchQuery} onChange={setSearchQuery} />
        </div>
      </div>

      {filteredPolicies.length === 0 ? (
        <div className="text-center py-16">
          <FileText className="mx-auto h-16 w-16 text-indigo-200 dark:text-indigo-500/30" />
          <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-gray-200">
            No policies found
          </h3>
          <p className="mt-2 text-gray-500 dark:text-gray-400">
            Try adjusting your search query
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {filteredPolicies.map(category => (
            <PolicyCategoryCard 
              key={category.category}
              category={category}
              isExpanded={expandedCategory === category.category}
              onToggle={() => setExpandedCategory(
                expandedCategory === category.category ? null : category.category
              )}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SettingsPage;
